const iconPicker = {
  pickIcon: "בחר אייקון",
  emoji: "אמוג׳י",
  icons: "אייקונים",
  image: "תמונה",
  search: "חפש...",
  all: "הכל",
  remove: "הסר אייקון",
  uploadFile: "העלה תמונה",
  uploading: "מעלה...",
  orPasteUrl: "או הדבק קישור לתמונה",
  apply: "החל",
  noResults: "לא נמצאו תוצאות",
  phosphor: "Phosphor",
  weight: "משקל",
  weightThin: "דק מאוד",
  weightLight: "דק",
  weightRegular: "רגיל",
  weightBold: "מודגש",
  weightFill: "מלא",
  size: "גודל",
  sizeAuto: "אוטומטי",
  weightDuotone: "דו-גוני",
} as const;
export default iconPicker;
